/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["span.badge[_ngcontent-%COMP%]{float:right;position:absolute;right:35px;top:15px}"];
export { styles as styles };
